import { createRoute } from '@tanstack/react-router';

import { HumanReviewTab } from '@/components/admin/HumanReviewTab';
import { StaffPage } from '@/components/admin/StaffPage';
import { seoHead } from '@/lib/seo/routeMeta';

import { Route as rootRoute } from './__root';

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/review',
  head: () => seoHead('/review'),
  component: ReviewPage,
});

function ReviewPage() {
  return (
    <StaffPage>
      <div className="space-y-6">
        <h1 className="text-2xl font-semibold">Review</h1>
        <HumanReviewTab />
      </div>
    </StaffPage>
  );
}
